import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "d-flex align-items-center gap-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "border border-dark rounded" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center symbol symbol-45px" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fa fa-user py-4 px-4",
      style: {"font-size":"25px"}
    })
  ])
], -1)
const _hoisted_4 = { class: "d-flex flex-column ms-0" }
const _hoisted_5 = {
  key: 0,
  class: "fw-bold fs-4 me-1"
}
const _hoisted_6 = { class: "d-flex align-items-center gap-2 fs-sm-5" }
const _hoisted_7 = { style: {"font-size":"12px"} }
const _hoisted_8 = {
  key: 1,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "far fa-calendar",
  style: {"font-size":"15px !important"}
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_11 = { class: "d-flex gap-2 ms-auto" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = {
  key: 0,
  class: "me-1"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Disimpan: ")
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = { class: "me-1" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Diinput Oleh: ")
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen text-white me-2" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "Edit", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "d-flex flex-column my-2" }
const _hoisted_23 = { class: "fw-bold text-justify fs-1 my-2" }
const _hoisted_24 = { class: "d-flex align-items-center justify-content-center my-2" }
const _hoisted_25 = {
  key: 0,
  class: "scroll-controls",
  style: {"margin-inline":"-14px","max-width":"75rem"}
}
const _hoisted_26 = {
  class: "d-flex align-items-center justify-content-center",
  style: {"z-index":"2"}
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_31 = ["src"]
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "d-flex align-items-center justify-content-center mt-2" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  class: "d-flex align-items-center justify-content-center",
  style: {"z-index":"2"}
}
const _hoisted_37 = ["disabled"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 1,
  class: "d-flex gap-2 mb-2"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "Sumber Berita:", -1)
const _hoisted_42 = ["href"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-share text-info me-1",
  style: {"font-size":"15px"}
}, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("small", { style: {"font-size":"12px"} }, "Kunjungi", -1)
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { class: "row" }
const _hoisted_48 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_49 = { class: "d-flex gap-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Program:", -1)
const _hoisted_51 = { class: "fs-5 fw-bold" }
const _hoisted_52 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_53 = { class: "d-flex gap-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Jenis Data:", -1)
const _hoisted_55 = { class: "fs-5 fw-bold" }
const _hoisted_56 = {
  key: 2,
  class: "col-md-3"
}
const _hoisted_57 = { class: "d-flex gap-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Berita Bergambar:", -1)
const _hoisted_59 = { class: "fs-5 fw-bold" }
const _hoisted_60 = {
  key: 3,
  class: "col-md-3"
}
const _hoisted_61 = { class: "d-flex gap-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Page:", -1)
const _hoisted_63 = { class: "fs-5 fw-bold" }
const _hoisted_64 = {
  key: 4,
  class: "col-md-3"
}
const _hoisted_65 = { class: "d-flex gap-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, [
  /*#__PURE__*/_createTextVNode("Durasi "),
  /*#__PURE__*/_createElementVNode("small", null, "(Detik)"),
  /*#__PURE__*/_createTextVNode(":")
], -1)
const _hoisted_67 = { class: "fs-5 fw-bold" }
const _hoisted_68 = {
  key: 5,
  class: "col-md-3"
}
const _hoisted_69 = { class: "d-flex gap-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Rate Per Detik:", -1)
const _hoisted_71 = { class: "fs-5 fw-bold" }
const _hoisted_72 = {
  key: 6,
  class: "col-md-3"
}
const _hoisted_73 = { class: "d-flex gap-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "AD Value:", -1)
const _hoisted_75 = { class: "fs-5 fw-bold" }
const _hoisted_76 = {
  key: 7,
  class: "col-md-3"
}
const _hoisted_77 = { class: "d-flex gap-2" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Kolom BW:", -1)
const _hoisted_79 = { class: "fs-5 fw-bold" }
const _hoisted_80 = {
  key: 8,
  class: "col-md-3"
}
const _hoisted_81 = { class: "d-flex gap-2" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Lebar BW:", -1)
const _hoisted_83 = { class: "fs-5 fw-bold" }
const _hoisted_84 = {
  key: 9,
  class: "col-md-3"
}
const _hoisted_85 = { class: "d-flex gap-2" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Rate BW:", -1)
const _hoisted_87 = { class: "fs-5 fw-bold" }
const _hoisted_88 = {
  key: 10,
  class: "col-md-3"
}
const _hoisted_89 = { class: "d-flex gap-2" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "AD Value BW:", -1)
const _hoisted_91 = { class: "fs-5 fw-bold" }
const _hoisted_92 = {
  key: 11,
  class: "col-md-3"
}
const _hoisted_93 = { class: "d-flex gap-2" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Kolom FC:", -1)
const _hoisted_95 = { class: "fs-5 fw-bold" }
const _hoisted_96 = {
  key: 12,
  class: "col-md-3"
}
const _hoisted_97 = { class: "d-flex gap-2" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Lebar FC:", -1)
const _hoisted_99 = { class: "fs-5 fw-bold" }
const _hoisted_100 = {
  key: 13,
  class: "col-md-3"
}
const _hoisted_101 = { class: "d-flex gap-2" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Rate FC:", -1)
const _hoisted_103 = { class: "fs-5 fw-bold" }
const _hoisted_104 = {
  key: 14,
  class: "col-md-3"
}
const _hoisted_105 = { class: "d-flex gap-2" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "AD Value FC:", -1)
const _hoisted_107 = { class: "fs-5 fw-bold" }
const _hoisted_108 = {
  key: 15,
  class: "col-md-3"
}
const _hoisted_109 = { class: "d-flex gap-2" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Sentiment:", -1)
const _hoisted_111 = { class: "fs-5 fw-bold" }
const _hoisted_112 = { class: "d-flex gap-2" }
const _hoisted_113 = { style: {"font-size":"12px"} }
const _hoisted_114 = {
  key: 16,
  class: "col-md-3"
}
const _hoisted_115 = { class: "d-flex gap-2" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Jurnalis:", -1)
const _hoisted_117 = { class: "fs-5 fw-bold" }
const _hoisted_118 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_119 = ["src"]
const _hoisted_120 = ["src"]
const _hoisted_121 = ["src"]

import { ref } from 'vue';
import { useRouter } from "vue-router";
import { profileSource, getSentiment, formatDateIndo } from "@/global-helper/handler";

interface IProps{
  data: any;
}
export default /*#__PURE__*/_defineComponent({
  props: {
    data: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
  data: any;
}
;


const data = ref(props.data);

const router = useRouter();

const dialogPreviewFile = ref(false);
const dialogFileUrl = ref('');

const scrollAmount = 975;
const postWrapper = ref<HTMLDivElement | null>(null);

const index_file = ref(1);

const scrollLeft = () => {
  if (postWrapper.value) {
    postWrapper.value.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    index_file.value -= 1;
  }
};

const scrollRight = () => {
  if (postWrapper.value) {
    postWrapper.value.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    index_file.value += 1;
  }
};

const disabled_carousel = (type: string) => {
    if (type === 'right') {
        if (index_file.value >= data.value.file_source.length) {
            return true;
        }
        return false;
    } else if (type === 'left') {
        if (index_file.value <= 1) {
            return true;
        }
        return false;
    }
    return false;
};

const handlePreview = (file) => {
    dialogFileUrl.value = file;
    dialogPreviewFile.value = true;
};

const goToRoute = (id: string, name: string, detail: boolean) => {
    if (detail) {
        window.open("/berita/detail/" + id);
    } else {
        router.push({ name: name, params: { id: id } });
    }
};

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        ('account' in data.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(data.value.account), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("i", {
            class: _normalizeClass(_unref(profileSource)(data.value.source).icon),
            style: _normalizeStyle(`color: ${_unref(profileSource)(data.value.source).color}; font-size: 15px !important`)
          }, null, 6),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(profileSource)(data.value.source).label), 1)
        ]),
        ('date' in data.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_unref(formatDateIndo)(data.value.date)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          ('date' in data.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(formatDateIndo)(data.value.created_at)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(data.value.author), 1)
          ])
        ]),
        _createElementVNode("button", {
          class: "btn btn-icon btn-bg-warning btn-active-color-warning btn-sm me-1",
          "data-bs-toggle": "tooltip",
          title: "Edit",
          style: {"width":"5rem"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goToRoute(data.value._id, 'berita-edit', false)))
        }, _hoisted_21)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, _toDisplayString(data.value.title), 1),
      _createElementVNode("div", _hoisted_24, [
        ('file_source' in data.value && Array.isArray(data.value.file_source) && data.value.file_source.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("button", {
                  class: "mr-3 btn btn-sm btn-primary",
                  disabled: disabled_carousel('left'),
                  onClick: scrollLeft
                }, _hoisted_29, 8, _hoisted_27), [
                  [_vShow, data.value.file_source.length > 1]
                ])
              ]),
              _createElementVNode("div", {
                class: "d-flex flex-nowrap post-items-wrapper gap-2",
                ref: (_value, _refs) => {
                  _refs['postWrapper'] = _value
                  postWrapper.value = _value
                }
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.file_source, (file, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    file
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_30, [
                            (data.value.source === 'media_cetak')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: file,
                                  height: "400",
                                  style: {"width":"74rem"}
                                }, null, 8, _hoisted_31))
                              : (data.value.source === 'media_tv' || data.value.source === 'running_text')
                                ? (_openBlock(), _createElementBlock("video", {
                                    key: 1,
                                    src: file,
                                    controls: "",
                                    height: "400",
                                    style: {"width":"74rem"}
                                  }, null, 8, _hoisted_32))
                                : (data.value.source === 'radio')
                                  ? (_openBlock(), _createElementBlock("audio", {
                                      key: 2,
                                      src: file,
                                      controls: "",
                                      style: {"width":"74rem"}
                                    }, null, 8, _hoisted_33))
                                  : _createCommentVNode("", true)
                          ]),
                          _withDirectives(_createElementVNode("div", { class: "d-flex align-items-center justify-content-center mt-2" }, _toDisplayString(index_file.value) + " / " + _toDisplayString(data.value.file_source.length), 513), [
                            [_vShow, data.value.file_source.length > 1]
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-primary",
                              onClick: ($event: any) => (handlePreview(file))
                            }, "Preview File", 8, _hoisted_35)
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 512),
              _createElementVNode("div", _hoisted_36, [
                _withDirectives(_createElementVNode("button", {
                  class: "mr-3 btn btn-sm btn-primary",
                  disabled: disabled_carousel('right'),
                  onClick: scrollRight
                }, _hoisted_39, 8, _hoisted_37), [
                  [_vShow, data.value.file_source.length > 1]
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("span", null, _toDisplayString(data.value.file_source), 1),
              _createElementVNode("a", {
                href: data.value.file_source,
                target: "_blank",
                class: "text-info ml-1"
              }, _hoisted_45, 8, _hoisted_42)
            ]))
      ]),
      _createElementVNode("p", {
        innerHTML: data.value.content,
        class: "text-justify fs-5 mt-2"
      }, null, 8, _hoisted_46)
    ]),
    _createElementVNode("div", _hoisted_47, [
      ('program' in data.value && (data.value.program !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("span", _hoisted_51, _toDisplayString(data.value.program), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('jenis_data' in data.value && (data.value.jenis_data !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("span", _hoisted_55, _toDisplayString(data.value.jenis_data), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('is_news_photo' in data.value && (data.value.is_news_photo !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("span", _hoisted_59, _toDisplayString(data.value.is_news_photo ? 'Ya' : 'Tidak'), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('page' in data.value && (data.value.page !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _createElementVNode("span", _hoisted_63, _toDisplayString(data.value.page), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('duration' in data.value && (data.value.duration !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("span", _hoisted_67, _toDisplayString(data.value.duration), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('rate_per_second' in data.value && (data.value.rate_per_second !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("span", _hoisted_71, _toDisplayString(data.value.rate_per_second), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('ad_value' in data.value && (data.value.ad_value !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createElementVNode("span", _hoisted_75, _toDisplayString(data.value.ad_value), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('column_bw' in data.value && (data.value.column_bw !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _hoisted_78,
              _createElementVNode("span", _hoisted_79, _toDisplayString(data.value.column_bw), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('wide_bw' in data.value && (data.value.wide_bw !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createElementVNode("span", _hoisted_83, _toDisplayString(data.value.wide_bw), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('rate_bw' in data.value && (data.value.rate_bw !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createElementVNode("span", _hoisted_87, _toDisplayString(data.value.rate_bw), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('ad_value_bw' in data.value && (data.value.ad_value_bw !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _hoisted_90,
              _createElementVNode("span", _hoisted_91, _toDisplayString(data.value.ad_value_bw), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('column_fc' in data.value && (data.value.column_fc !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _hoisted_94,
              _createElementVNode("span", _hoisted_95, _toDisplayString(data.value.column_fc), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('wide_fc' in data.value && (data.value.wide_fc !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _hoisted_98,
              _createElementVNode("span", _hoisted_99, _toDisplayString(data.value.wide_fc), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('rate_fc' in data.value && (data.value.rate_fc !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              _hoisted_102,
              _createElementVNode("span", _hoisted_103, _toDisplayString(data.value.rate_fc), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('ad_value_fc' in data.value && (data.value.ad_value_fc !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _hoisted_106,
              _createElementVNode("span", _hoisted_107, _toDisplayString(data.value.ad_value_fc), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('sentiment' in data.value && (data.value.sentiment !== ''))
        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _hoisted_110,
              _createElementVNode("span", _hoisted_111, [
                _createElementVNode("div", _hoisted_112, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_unref(getSentiment)(data.value.sentiment).icon),
                    style: {"font-size":"15px !important"}
                  }, null, 2),
                  _createElementVNode("span", _hoisted_113, _toDisplayString(_unref(getSentiment)(data.value.sentiment).label), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ('journalist' in data.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
            _createElementVNode("div", _hoisted_115, [
              _hoisted_116,
              _createElementVNode("span", _hoisted_117, _toDisplayString(data.value.journalist), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogPreviewFile.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogPreviewFile).value = $event)),
      title: "Preview File Berita",
      width: "900"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_118, [
          (data.value.source === 'media_cetak')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: dialogFileUrl.value,
                width: "800"
              }, null, 8, _hoisted_119))
            : (data.value.source === 'media_tv' || data.value.source === 'running_text')
              ? (_openBlock(), _createElementBlock("video", {
                  key: 1,
                  src: dialogFileUrl.value,
                  controls: "",
                  height: "400",
                  width: "500"
                }, null, 8, _hoisted_120))
              : (data.value.source === 'radio')
                ? (_openBlock(), _createElementBlock("audio", {
                    key: 2,
                    src: dialogFileUrl.value,
                    controls: "",
                    width: "500"
                  }, null, 8, _hoisted_121))
                : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})